import { Box } from "@mui/material"
import React from "react"
import { useSearchParams } from "react-router-dom"

export function BlueprintUserInterface() {
  const [searchParams] = useSearchParams()

  const agentId = searchParams.get("agentId")

  let iframeUrl = "https://dca-bot-git-v2-aut-research.vercel.app"
  // let iframeUrl = "http://localhost:3001"

  if (agentId) {
    iframeUrl = `${iframeUrl}?agentId=${agentId}`
  }

  // const iframeRef = useRef<HTMLIFrameElement>(null)

  // useEffect(() => {
  //   if (iframeRef.current) {
  //     iframeRef.current.onload = () => {
  //       if (iframeRef?.current?.contentWindow) {
  //         iframeRef.current.contentWindow.arweaveWallet = window.arweaveWallet
  //       }
  //     }
  //   }
  // }, [iframeRef])

  return (
    <Box
      // ref={iframeRef}
      component="iframe"
      src={iframeUrl}
      border={0}
      sx={{
        height: "calc(100vh - 400px)",
        width: "100%",
        borderRadius: 1,

        border: "1px solid var(--mui-palette-divider)",
      }}
    />
  )
}
